import '../../../../vendor/angular-ui-bootstrap/src/position/position.js';

export const uiBootstrapPositionModule = 'ui.bootstrap.position';
